import { useContext } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { SidebarContext } from '../../../../App';
import { ReportSection } from '../../../../core/constants/common';
import { getTranslation } from '../../../../core/utilities/TranslationHelpers';
import './../Reporting.scss';

const BRSRReportingSidebar = ({
  t,
  sections,
  activeSectionIndex,
  language,
  onPageChange
}) => {
  const { i18n } = useTranslation();
  const { sidebarDisplay } = useContext(SidebarContext);

  const canRenderSection = (section) => {
    return section.type === ReportSection.TITLE 
    || section.type === ReportSection.SECTION 
    || section.type === ReportSection.PRINCIPLE;
  };

  const getSectionName = (section) => {
    if (section.type === ReportSection.TITLE) {
      return "Cover Page";
    } else if (section.type === ReportSection.SECTION) {
      return section.name || "SECTION";
    } else if (section.type === ReportSection.PRINCIPLE) {
      return section.name || "PRINCIPLE";
    }
    return section.name || getTranslation(i18n, "Section.label", language || i18n.language);
  };

  return (
    <div className={`Reporting_SiderBar ${sidebarDisplay ? '' : 'left-44'}`}>
      <ul className='Reporting_siderBar_ul'>
        {
          sections?.filter(section => canRenderSection(section))
            ?.map((section, sIndex) => {
              return (
                <li key={`sectionItem-${sIndex}`} className='active'>
                  <div className='d-flex align-items-center'>
                    <span className='cursor me-2'></span>
                    <a
                      className={activeSectionIndex === section.index ? 'cursor active flex-grow-1' : 'cursor flex-grow-1'}
                      onClick={() => {
                        if (section.pages?.length > 0) {
                          onPageChange(section.index, section.pages[0].index);
                        }
                      }}
                    >
                      <strong>{getSectionName(section)}</strong>
                    </a>
                  </div>
                </li>
              );
            })
        }
      </ul>
    </div>
  );
};

export default withTranslation()(BRSRReportingSidebar);
